jQuery(function ($) {
	var currentPath = window.location.pathname;

	// Ensure the active class is retained on menu items when query params are present
	$(".nav-item a").each(function () {
		var linkPath = $(this).attr("href");

		if (currentPath === linkPath) {
			$(this).parent().addClass("current-menu-item active");
		}
	});
});
